import { render, staticRenderFns } from "./ModificarPreembarque.vue?vue&type=template&id=6e5096c2&scoped=true&"
import script from "./ModificarPreembarque.vue?vue&type=script&lang=js&"
export * from "./ModificarPreembarque.vue?vue&type=script&lang=js&"
import style0 from "./ModificarPreembarque.vue?vue&type=style&index=0&id=6e5096c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5096c2",
  null
  
)

export default component.exports